{
  "time_range_error_message": "A hora de término deve ser posterior à hora de início",
  "attribute_list_items": "itens da lista de atributos",
  "attribute_list_item": "item da lista de atributos",
  "attribute_list_item_order": "ordem dos itens da lista de atributos"
}